/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./vue.tailwind.theme.js');

// import Alpine from 'alpinejs';
// window.Alpine = Alpine;
// Alpine.start();

import Vue from 'vue';
// import 'livewire-vue';
window.Vue = Vue;

// import Vuetify from './vuetify.js';

import VueAWN from "vue-awesome-notifications";
import "vue-awesome-notifications/dist/styles/style.css";

require('./filters.js');

// Export Ziggy to Vue's scope
Vue.mixin({
    methods: {
        route: route,

        navigate(url, newTab=false) {
            if(newTab) {
                window.open(url);
                return;
            }
            window.location.href = url;
        },

        isOnline() {
            return window.navigator.onLine;
        },

        openLink(url) {
            window.open(url);
        }
    }
});

Vue.use(VueAWN, {
    labels: {
        info: "Informazione",
        success: "Operazione eseguita",
        warning: "Attenzione!",
        alert: "Errore!",
        confirm: "Conferma richiesta",
        confirmOk: "OK",
        confirmCancel: "Annulla",
        async: "Attendere..."
    },
    messages: {
        async: "Attendere, prego",
        "asyn-block": "Elaborazione in corso..."
    },
    durations: {
        global: 10000
    }
});

// import LaravelVuePagination from 'laravel-vue-tailwind-pagination';

// Vue.use(LaravelVuePagination);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./components', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.prototype.console = console;
Vue.prototype.axios = axios;

const app = new Vue({
    el: '#app',
    data() {
        return {
            sidebarOpen: false
        };
    }
    // vuetify: Vuetify
});
